import { UserManagerSettings, WebStorageStateStore } from 'oidc-client';
import { createUserManager } from 'redux-oidc';
import Constants from './constants';

const baseUrl = window.location.protocol + '//' + window.location.host;

// Documentation on how to use this configuration and the UserManager can be found here:
// https://github.com/IdentityModel/oidc-client-js/wiki

const userManagerConfig: UserManagerSettings = {
	client_id: 'SurveyBuilderWeb',
	redirect_uri: baseUrl + '/callback',
	response_type: 'token id_token',
	scope:
		'openid profile SurveyBuilderAPI SurveyEngineAPI QuestionLibraryAPI NormLibraryAPI UserManagementAPI' +
		' AuthAPI VirusScanAPI PeopleManagerAPI HierarchyManagerAPI',
	authority: Constants.IDENTITY_SERVER_URL,
	silent_redirect_uri: baseUrl + '/silentrenew',
	automaticSilentRenew: true,
	filterProtocolClaims: true,
	loadUserInfo: true,
	monitorSession: true,
	post_logout_redirect_uri: baseUrl,
	userStore: new WebStorageStateStore({ store: window.localStorage }),
	revokeAccessTokenOnSignout: true,
};

const userManager: any = createUserManager(userManagerConfig);

export default userManager;
